import { TClient } from "~/types";
import { baseService } from "../base";
import { PaginationResponse } from "../type";
import { QueryClientParams } from "./client.types";

export const clientServices = {
  getClients: async (params?: QueryClientParams) => {
    const { data } = await baseService.get<PaginationResponse<TClient>>(
      "/clients",
      {
        params: params ?? {
          page: 1,
          pageSize: 50,
        },
      }
    );
    return data;
  },
  getClient: async (id: string) => {
    const { data } = await baseService.get<TClient>(`/clients/${id}`);
    return data;
  },
  getSubClient: async (clientId: string) => {
    const { data } = await baseService.get<PaginationResponse<TClient>>(
      `/clients/${clientId}/sub-clients`
    );
    return data;
  },
  createClient: async (formData: FormData) => {
    const { data } = await baseService.post("/clients", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  },
  updateClient: async ({
    id,
    formData,
  }: {
    id: string;
    formData: FormData;
  }) => {
    const { data } = await baseService.patch(`/clients/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  },
  importFromCsv: async (formData: FormData) => {
    const { data } = await baseService.post("/clients/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  },
  deleteClient: async (id: string) => {
    const { data } = await baseService.delete(`/clients/${id}`);
    return data;
  },
  createServiceRequest: async (payload: any) => {
    const { data } = await baseService.post("/clients/service-request", payload);
    return data;
  },
};
